export const release = "05-NOV-26 16:41:59";
export const lemmonEnv: any = (globalThis as any).lemmonEnv;
